import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  IconButton,
  Modal,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useParams } from "react-router-dom";
import { httpClient } from "../../axios";

const TaskListEmp = () => {
  const { empId } = useParams();
  const [tasks, setTasks] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const fetchEmployeeTasks = async () => {
      try {
        const response = await httpClient.get(`/employee/get/${empId}`);
        const employeeData = response.data;

        if (employeeData.tasks && employeeData.tasks.length > 0) {
          setTasks(employeeData.tasks);
        } else {
          setError("No tasks found for this employee.");
        }
      } catch (error) {
        console.error("Error fetching employee tasks:", error);
        setError("Failed to fetch employee data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (empId) {
      fetchEmployeeTasks();
    }
  }, [empId]);

  const handleViewTask = async (taskId) => {
    try {
      const response = await httpClient.get(`/task/get/${taskId}`);
      setSelectedTask(response.data);
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching task details:", error);
    }
  };

  return (
    <Box sx={{ maxWidth: 900, margin: "auto", mt: 4 }}>
      {loading ? (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Loading tasks...
        </Typography>
      ) : error ? (
        <Typography variant="body2" color="error" textAlign="center">
          {error}
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {tasks.map((task) => (
            <Grid item xs={12} sm={6} md={4} key={task.taskId}>
              <Card
                sx={{
                  p: 2,
                  boxShadow: 5,
                  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 8,
                  },
                  position: "relative",
                }}
              >
                <IconButton
                  sx={{ position: "absolute", top: 8, right: 8 }}
                  onClick={() => handleViewTask(task.taskId)}
                >
                  <VisibilityIcon />
                </IconButton>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {task.taskName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Start Date:</strong> {task.startDate}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>End Date:</strong> {task.endDate}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Status:</strong> {task.taskStatus}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Priority:</strong> {task.taskPriority}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Pending Reason:</strong> {task.taskPendingReason}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Assigned To:</strong> {task.employeeName}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          {selectedTask ? (
            <>
              <Typography variant="h6" gutterBottom>
                {selectedTask.taskName}
              </Typography>
             
              <Typography variant="body2" color="text.secondary">
                <strong>Start Date:</strong> {selectedTask.startDate}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>End Date:</strong> {selectedTask.endDate}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Status:</strong> {selectedTask.taskStatus}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Priority:</strong> {selectedTask.taskPriority}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Pending Reason:</strong> {selectedTask.taskPendingReason}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Assigned To:</strong> {selectedTask.employeeName}
              </Typography>
            </>
          ) : (
            <Typography>Loading task details...</Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default TaskListEmp;
